import React, {useEffect, useState} from 'react';
import {Dialog, DialogActions, DialogContent, DialogTitle, IconButton} from "@mui/material";
import ShowPageContent from "../../pages/front/pages/ShowPageContent";
import Button from "@mui/material/Button";
import {useTranslation} from "react-i18next";
import Title from "./Title";
import axios from "axios";
import {defaultVariables} from "../../../config";
import {connect, setStore} from "trim-redux";
import {updateRedux} from "../../../config/Security";
import {CircleCheckBigIcon} from "lucide-react";
import CloseIcon from "@mui/icons-material/Close";
import {withStyles} from "@mui/styles";
import {Styles} from "../../../config/design/styles";


function SignContractDialog(props) {
    let [open,setOpen] = useState(false);
    let [page,setPage] = useState(null);
    let [slug,setSlug] = useState("suppliers-contract");
    const { t } = useTranslation();
    const setPageResult = (data) => {
        setPage(data);
    }
    const loginToken = localStorage.getItem('ACT');

    const config = {
        headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${loginToken}`,

        }
    }
    const handleAcceptContract = () => {
        setOpen(false);
        axios.get(`${defaultVariables.url}/users/accept-contract`,config)
            .then(response => {
                updateRedux();
            })
            .catch(error => {
                console.error("Error fetching item data:", error);
            });
    }
    useEffect(() => {
        if(!props.view){
            setOpen(true);
        }
    }, []);
    useEffect(() => {
        let industry_id = props.user?.shop?.industry_id;
        if(industry_id === 1){
            setSlug("suppliers-contract");
        }else if (industry_id === 2){
            setSlug("markets-contract");
        }else{
            if(props.industry === 'markets'){
                setSlug("markets-contract");
            }else{
                setSlug("suppliers-contract");
            }
        }
    }, [props.user]);
    return (
        <>
            {
                !!props.view &&
                <Button
                    onClick={() => setOpen(true)}
                >
                    {t('viewContract')}
                </Button>
            }
            <Dialog fullWidth maxWidth='lg' open={open}>
                <DialogTitle className="vendor-co-title">
                    <Title align="left" color="text">{page?.data?.name}</Title>
                    {
                        !!props.view &&
                        <IconButton aria-label="close" className={props.classes.dialogClose} onClick={() => setOpen(false)}>
                            <CloseIcon/>
                        </IconButton>
                    }
                </DialogTitle>
                <DialogContent style={{maxHeight:"55vh"}}>
                    <ShowPageContent slug={slug} setPageData={(data) => setPageResult(data)}/>
                </DialogContent>
                {
                    !props.view &&
                    <DialogActions className="vendor-co-dialog" style={{justifyContent:"center"}}>
                        <Button
                            onClick={() => handleAcceptContract()}
                            variant="contained"
                            color="secondary"
                            startIcon={<CircleCheckBigIcon/>}
                        >
                            {t('iVeReadAndAcceptContract')}
                        </Button>
                    </DialogActions>
                }

            </Dialog>
        </>
    );
}
const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user
});

export default withStyles(Styles)(connect(mstp)(SignContractDialog));